import { toastSuccess, toastWarning } from "../../toasts.js";
import { BonusParameters, BonusParametersInput, BonusParametersReHydrated, isBonusParameters, isBonusParametersInput } from "../../types/BonusParameters.js";
import { StepsComponent } from "../base-components/steps-component.js";
import { BonusParamItemValue } from "./bonus-param-item-value.js";
import { BonusParamItemComponent } from "./bonus-param-item.js";
import { BonusParamItemGroupComponent } from "./bonus-parameters-group.js";

export class BonusParametersComponent extends StepsComponent {
    static webComponentName = "bonus-parameters";
    static observedAttributes: string[] = ['readonly'];
    protected _templateId: string = "bonus-parameters-main";
    protected _step: string = "bonus-parameters-view"; // Default step for bonus parameters

    constructor() {
        super();
    }
    protected onConnected(): void {
        const dataRaw = this.attributeStringOption('data-raw', null); // Placeholder for future use
        if (dataRaw) {
            try {
                const parsedData = JSON.parse(dataRaw);
                if (isBonusParametersInput(parsedData)) {
                    this.inputValue = parsedData;
                }
                else {
                    console.warn("BonusParametersComponent: data-raw is not a valid BonusParametersInput.", parsedData);
                }
            }
            catch (error) {
                console.error("BonusParametersComponent: Failed to parse data-raw JSON.", error);
            }
        }
        super.onConnected();
    }
    get value(): BonusParameters {
        const groups: BonusParameters = [];
        const groupElements = Array.from(this.querySelectorAll('bonus-parameters-group')) as BonusParamItemGroupComponent[];
        groupElements.forEach((groupEl) => {
            const items = Array.from(groupEl.querySelectorAll('bonus-param-item')) as BonusParamItemComponent[];
            const groupValues = items
                .map(item => item.value)
                .filter((v): v is NonNullable<typeof v> => v !== null);
            if (groupValues.length > 0) {
                groups.push(groupValues);
            }
        });
        // Garantisce almeno un gruppo vuoto se non ci sono valori validi
        return groups.length > 0 ? groups : [[]];
    }
    get readonly(): boolean {
        return this.getBooleanAttribute('readonly');
    }
    // get set della proprietà inputValue tipo BonusParametersInput
    private _inputValue!: BonusParametersInput;
    private addBonusParameterBtn!: HTMLAnchorElement;
    get inputValue(): BonusParametersInput {
        if (this._inputValue == undefined) {
            this._inputValue = [[]];
        }
        return this._inputValue;
    }
    set inputValue(value: BonusParametersInput) {
        if (!isBonusParametersInput(value)) {
            console.warn("BonusParametersComponent: inputValue is not a valid BonusParametersInput.", value);
            return;
        }
        this._inputValue = value;
        this._currentSet = this.normalizeInputValue(value); // Normalize inputValue to BonusParameters
        this.render();
    }
    // consente di impostare inputValue da dati non tipizzati
    set inputValueRaw(value: any) {
        if (isBonusParametersInput(value)) {
            this.inputValue = value as BonusParametersInput;
        }
        else {
            console.info("BonusParametersComponent: inputValueRaw is not a valid BonusParametersInput.", value);
        }
    }
    // currentSet è inputValue normalizzato in BonusParameters
    private _currentSet!: BonusParameters;
    protected get currentSet(): BonusParameters {
        return this._currentSet;
    }

    protected normalizeInputValue(inputValue: BonusParametersInput): BonusParameters {
        if (isBonusParameters(inputValue)) {
            return inputValue as BonusParameters; // Already in the correct format
        }
        if (!Array.isArray(inputValue)) {
            console.warn("BonusParametersComponent: inputValue is not an array, normalizing to empty array.");
            return [] as BonusParameters; // Normalize to empty array if not an array
        }
        // Normalize inputValue to BonusParameters format
        const normalized: BonusParameters = [inputValue];
        return normalized;
    }
    protected buildRenderingData(): Record<string, any> {
        return {
            set: this.currentSet,
            readonly: this.readonly
        };
    }
    addGroup(): BonusParamItemGroupComponent | null {
        const tmpEl = document.createElement('div');
        tmpEl.innerHTML = `<bonus-parameters-group class="">
            <span class="items-container" style="display: contents;">
                <bonus-param-item class="invalid" parameter-id="" value=''></bonus-param-item>
            </span>
            <a href="#" role="add-param-item">
                <i class="bi bi-plus-circle-fill text-success"></i>
            </a>
        </bonus-parameters-group>`;
        const bonusParametersGroup = tmpEl.firstElementChild as BonusParamItemGroupComponent;
        if (bonusParametersGroup == undefined) {
            console.warn("BonusParametersComponent: addGroup failed, bonusParametersGroup is undefined.");
            toastWarning("Impossibile creare un nuovo gruppo di parametri");
            return null;
        }
        this.querySelector('span.groups-container')?.appendChild(bonusParametersGroup);
        tmpEl.remove();
        toastSuccess("Nuovo gruppo di parametri aggiunto");
        return bonusParametersGroup;
    }
    protected afterRender(): void {
        this.addBonusParameterBtn = this.roleElementSelector('add-bonus-parameter-btn') as HTMLAnchorElement;
        if (this.addBonusParameterBtn) {
            this.addBonusParameterBtn.addEventListener('click', (event: MouseEvent) => {
                event.preventDefault();
                const newItem = this.addGroup();
            });
        }
        super.afterRender();
    }
    protected render(): void {
        if (this.inputValue == undefined) {
            console.warn("BonusParametersComponent: inputValue is undefined, cannot render.");
            return;
        }

        if (!isBonusParameters(this.currentSet)) {
            // return ;
        }
        super.render();
    }
    static registerElement(): void {
        // in questo caso registra anche tutti i componenti figli
        BonusParamItemComponent.registerElement();
        BonusParamItemValue.registerElement();
        BonusParamItemGroupComponent.registerElement();
        super.registerElement();
    }
}